import { EDITPROFILE_SUCCESS, EDITPROFILE_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const editProfileReducer = (state = initialState, action) => {
    switch (action.type) {
        case EDITPROFILE_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case EDITPROFILE_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }
    return state;
};

export default editProfileReducer;
